import { render, staticRenderFns } from "./FormDonationItems.vue?vue&type=template&id=5566c703"
import script from "./FormDonationItems.vue?vue&type=script&lang=js"
export * from "./FormDonationItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports